import React from "react";
import { brand, footerColumns } from "@/config/brand";
import { FooterLinks, FooterNewsletter, FooterSocial } from "@/components/layout/FooterSections";

export function Footer() {
  return (
    <footer className="bg-ink text-ivory" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h2 className="font-serif text-3xl font-light tracking-[0.18em]">{brand.name}</h2>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-ivory/60">{brand.tagline}</p>
            <FooterNewsletter />
            <FooterSocial />
          </div>
          <FooterLinks columns={footerColumns} />
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-ivory/10 pt-8 sm:flex-row">
          <p className="text-xs text-ivory/50">© {new Date().getFullYear()} {brand.name}. All rights reserved.</p>
          <p className="text-xs text-ivory/50">Crafted with care in India · Secure Payments</p>
        </div>
      </div>
    </footer>
  );
}
